import axios from 'axios';

class ConfigService {
  constructor() {
    this.config = null;
  }

  async initialize() {
    if (this.config) return this.config;
    try {
      // Fetches runtime configuration as described in README.md
      const response = await axios.get('/config/runtime-config.json');
      this.config = response.data;
      return this.config;
    } catch (error) {
      console.warn('ConfigService: Failed to fetch runtime config, using defaults.');
      // Return empty object to prevent downstream destructuring errors
      return {};
    }
  }
}

export default new ConfigService();